import { AccordionData } from '../../../../../../../components/Accordion/Accordion';
import { StepsNavigationName } from '../../../../../../../config/services';
import { formatDate } from '../../../../../../../helpers/dates';
import { parseFormDataValue } from '../../../../../../../helpers/parseFormDataValue';
import { NullValueGuard } from '../../../../../../../middlewares/NullValueGuard';

import { TransitDocumentFieldName, TransitDocumentFormDataProps } from './types';

interface PreviewProps {
  formData: TransitDocumentFormDataProps;
}

export const previewTransitDocument = ({ formData }: PreviewProps): AccordionData => {
  return {
    title: StepsNavigationName.directionOfTransportation,
    content: (
      <>
        <div className="custom-columns custom-columns_grey-bg custom-columns_default-gap">
          <div className="custom-columns__row custom-columns__row_padding-tiny">
            <div className="custom-columns__col">
              <div className="custom-columns__title">Країна, куди прямує вантаж</div>
              <div className="custom-columns__info">
                <NullValueGuard>
                  {parseFormDataValue(formData[TransitDocumentFieldName.toCountry])?.label}
                </NullValueGuard>
              </div>
            </div>
            <div className="custom-columns__col">
              <div className="custom-columns__title">Країна, звідки прямує вантаж</div>
              <div className="custom-columns__info">
                <NullValueGuard>
                  {parseFormDataValue(formData[TransitDocumentFieldName.fromCountry])?.label}
                </NullValueGuard>
              </div>
            </div>
          </div>

          <div className="custom-columns__content-title">
            Країни, через які буде здійснюватися зворотнє вивезення (ввезення)
          </div>

          <div className="custom-columns__row custom-columns__row_padding-tiny">
            <div className="custom-columns__col">
              <div className="custom-columns__title">Країна 1</div>
              <div className="custom-columns__info">
                <NullValueGuard>
                  {parseFormDataValue(formData[TransitDocumentFieldName.transitCountry])?.label}
                </NullValueGuard>
              </div>
            </div>
            <>
              {Object.keys(formData)
                .filter((key) => key.startsWith('transitCountry_'))
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                .map((key) => (formData as any)[key])
                .filter(Boolean)
                .map((nonParsedItem, index) => (
                  <div className="custom-columns__col" key={Number(index)}>
                    <div className="custom-columns__title">Країна {index + 2}</div>
                    <div className="custom-columns__info">
                      {parseFormDataValue(nonParsedItem) ? parseFormDataValue(nonParsedItem)?.label : '-'}
                    </div>
                  </div>
                ))}
            </>
          </div>

          <div className="custom-columns__row custom-columns__row_padding-tiny">
            <div className="custom-columns__col">
              <div className="custom-columns__title">Країна, у яку повертається вантаж</div>
              <div className="custom-columns__info">
                <NullValueGuard>
                  {parseFormDataValue(formData[TransitDocumentFieldName.returnCountry])?.label}
                </NullValueGuard>
              </div>
            </div>
            <div className="custom-columns__col">
              <div className="custom-columns__title">Митний пункт пропуску</div>
              <div className="custom-columns__info">
                <NullValueGuard>{formData[TransitDocumentFieldName.customs]}</NullValueGuard>
              </div>
            </div>
          </div>

          <div className="custom-columns__row custom-columns__row_padding-tiny">
            <div className="custom-columns__col">
              <div className="custom-columns__title">Термін дії дозвілу</div>
              <div className="custom-columns__info">
                <NullValueGuard>
                  {formatDate(formData[TransitDocumentFieldName.permitExpiredAt] ?? null)}
                </NullValueGuard>
              </div>
            </div>
            <div className="custom-columns__col">
              <div className="custom-columns__title">Мета звернення</div>
              <div className="custom-columns__info">
                <NullValueGuard>{formData[TransitDocumentFieldName.purpose]}</NullValueGuard>
              </div>
            </div>
          </div>
        </div>
      </>
    ),
  };
};
